import { useContext } from 'react'

import { TierContext } from '../providers/TierProvider'

export const useTierContext = () => {
  const tierContext = useContext(TierContext)

  if (tierContext === undefined) {
    throw new Error('tierContext must be used within a TierProvider')
  }

  return tierContext
}
